module.exports = __webpack_public_path__ + "static/media/cc_icon-amex.8f27d138.svg";